import $ from 'jquery'
import './jquery-resize-debounce'
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import googleCalendarPlugin from '@fullcalendar/google-calendar'
$(document).ready(function() {
	const calendarEle = document.getElementById('fw-calendar')
	const isHomeCalendar = $('#fw-calendar').hasClass('home-calendar')
	let count = 0
	const tellMeTheView = () => {
		if (isHomeCalendar) {
			return 'listMonth'
		} else {
			return $(window).width() < 768 ? 'listWeek' : 'dayGridMonth'
		}
	}

	if (calendarEle) {
		const useGoogleCalendar = calendarEle.getAttribute('data-source-google') == 1
		const googleCalendarId = calendarEle.getAttribute('data-google-cid')
		const googleCalendarApiKey = calendarEle.getAttribute('data-google-api')
		const now = new Date()
		const nowLocalString = now.toLocaleString()
		const mmTemp = now.getMonth() + 1
		const ddTemp = now.getDate()
		const yyyy = now.getFullYear()
		const mm = mmTemp < 10 ? '0' + mmTemp : mmTemp
		const dd = ddTemp < 10 ? '0' + ddTemp : ddTemp
		const todayFormatted = yyyy + '-' + mm + '-' + dd

		let homeCalendarScrolled = false

		const calendar = new Calendar(calendarEle, {
			...{
				plugins: [
					...(useGoogleCalendar ? [googleCalendarPlugin] : []),
					...[dayGridPlugin, listPlugin]
				],
				defaultView: tellMeTheView(),
				header: {
					left: isHomeCalendar ? 'title' : 'prev,next',
					center: isHomeCalendar ? '' : 'title',
					right: isHomeCalendar ? 'prev,next' : 'dayGridMonth,listWeek'
				},

				events: useGoogleCalendar
					? {
							googleCalendarId: googleCalendarId
					  }
					: wp_data.home_url + '/wp-admin/admin-ajax.php?action=fw_get_events',

				eventPositioned: e => {
					isHomeCalendar && !homeCalendarScrolled ? homeScrollToToday(e) : null
				},
				loading: function(bool) {
					$('#fw-calendar-loading').toggle(bool)
					$('#fw-calendar').toggleClass('waiting', bool)
				},
				eventClick: function(info) {
					info.jsEvent.preventDefault()
					if (info.event.url) {
						window.open(
							useGoogleCalendar
								? info.event.url + '&ctz=' + calendarEle.getAttribute('data-timezone')
								: info.event.url
						)
					}
				}
			},
			...(useGoogleCalendar ? { googleCalendarApiKey: googleCalendarApiKey } : {}),
			...(isHomeCalendar
				? {
						titleFormat: {
							month: 'long'
						},
						listDayFormat: {
							day: '2-digit'
						},
						displayEventTime: false
				  }
				: {})
		})

		const calendarViewerChanger = () => {
			calendar.changeView(tellMeTheView())
		}

		const homeScrollToToday = e => {
			const eventLocalString = e.event.start.toLocaleString()
			if (
				nowLocalString.split(',')[0] == eventLocalString.split(',')[0] ||
				nowLocalString.split(' ')[0] == eventLocalString.split(' ')[0]
			) {
				const today_object = $('.fc-list-heading[data-date=' + todayFormatted + ']')
				$('.fc-scroller').animate({
					scrollTop: today_object.length > 0 ? today_object[0].offsetTop : 0
				})
				homeCalendarScrolled = true
			}
		}

		//Render the calendar;
		calendar.render()

		//Double check for "scroll to today", sometimes there are multi-day events showing on the day;
		setTimeout(function() {
			if (!homeCalendarScrolled) {
				const today_object = $('.fc-list-heading[data-date=' + todayFormatted + ']')
				$('.fc-scroller').animate({
					scrollTop: today_object.length > 0 ? today_object[0].offsetTop : 0
				})
			}
		}, 1000)

		$(window).smartresize(function() {
			calendarViewerChanger()
		})
	}
})
